import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openBuyPlanModal } from "../store/slices/ui";

const ProtectedRoutes = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { profilelist = {} } = useSelector((state) => state.profile);

  const storedUser = JSON.parse(localStorage.getItem("user") || "null");
  const currentUser = user || storedUser;
  const storedRole = storedUser?.role;

  // Pages accessible without membership
  const allowedWithoutPlan = [
    "/user/home",
    "/user/membership",
    "/user/verify-aadhaar",
    "/user/checkout",
  ];
  // Open Buy Plan modal
  useEffect(() => {
    if (
      profilelist?.hasActivePlan === false &&
      !allowedWithoutPlan.includes(location.pathname)
    ) {
      dispatch(openBuyPlanModal());
    }
  }, [
    dispatch,
    profilelist?.hasActivePlan,
    location.pathname,
  ]);

  // Not logged in
  if (!currentUser && !isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Role check
  if (currentUser?.role && currentUser.role !== "user") {
    return <Navigate to="/" replace />;
  }

  if (storedRole !== "user") {
    return <Navigate to="/" replace />;
  }

  // Aadhaar verification
  if (
    profilelist?.aadhaarVerified === false &&
    location.pathname !== "/user/verify-aadhaar"
  ) {
    return <Navigate to="/user/verify-aadhaar" replace />;
  }

  // Membership check
  if (
    profilelist?.hasActivePlan === false &&
    !allowedWithoutPlan.includes(location.pathname)
  ) {
    return <Navigate to="/user/home" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;